import {ApiClient} from '@hconnect/apiclient'
import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {MaterialStorage} from '../types'

export const MaterialStorageQueryKey = 'material-storage'

type Params = {
  plantId: string
  snapshotDateTime: string
  options?: Omit<UseQueryOptions<MaterialStorage[], AxiosError>, 'queryKey' | 'queryFn'>
}

export const useMaterialStorage = ({plantId, snapshotDateTime, options}: Params) =>
  useQuery<MaterialStorage[], AxiosError>({
    queryKey: [MaterialStorageQueryKey, snapshotDateTime, plantId],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<MaterialStorage[]>(
        `/plants/${plantId}/material-storage/history/${snapshotDateTime}`,
        {signal}
      )
      return response.data || []
    },
    ...options
  })
